// extracted by mini-css-extract-plugin
export default {"wrapper":"Qp-z","response":"Rp-z","error":"Sp-z","disabled":"Tp-z","buttons":"Up-z","feedbackQuestionSection":"Vp-z","yesNoWrapper":"Wp-z"};